module.exports = __webpack_public_path__ + "static/media/serv-tai-small.5f3b619c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/services/serv-tai-small.jpg
// module id = 485
// module chunks = 0